
const reportFrameStyle = {
  border: 0
};

type Props = {
  src: string
  height: string|number|undefined
  width: string|number|undefined
}

export const Iframe = (props:Props) => {
    return(         
      <div>          
        <iframe src={props.src} height={props.height} width={props.width} frameBorder='0' style={reportFrameStyle} allowFullScreen/>         
      </div>
    )
}

